import React, { FC, useState } from 'react';
import { Layout, Row, Col, Tabs } from 'antd';
import { AudioOutlined, UploadOutlined, FileTextOutlined } from '@ant-design/icons';
import { SpeechToInsightsStyle } from './SpeechToInsights.jss';
import { AudioMicTab } from '../../components/AudioMicTab/AudioMicTab';
import { AudioFileTab } from '../../components/AudioFileTab/AudioFileTab';
import { VTTFileTab } from '../../components/VTTFileTab/VTTFileTab';
import { SpeechResults } from '../../components/SpeechResults/SpeechResults';

const { TabPane } = Tabs;

const SpeechToInsights: FC = () => {
    const style = SpeechToInsightsStyle();
    const [isProcessing, setIsProcessing] = useState(false);
    const [transcriptContent, setTranscriptContent] = useState('');

    return (
        <Layout className={style.layout}>
            <Row gutter={[24, 24]}>
                <Col span={24}>
                    <Tabs defaultActiveKey="mic" centered={true}>
                        <TabPane tab="Audio del Micrófono" key="mic" disabled={isProcessing} icon={<AudioOutlined />}>
                            <AudioMicTab 
                                setIsProcessing={setIsProcessing} 
                                setTranscriptContent={setTranscriptContent}
                            />
                        </TabPane>
                        <TabPane tab="Audio Adjunto" key="audio" disabled={isProcessing} icon={<UploadOutlined />}>
                            <AudioFileTab 
                                setIsProcessing={setIsProcessing} 
                                isProcessing={isProcessing}
                            />
                        </TabPane>
                        <TabPane tab="Archivo VTT" key="vtt" disabled={isProcessing} icon={<FileTextOutlined />}>
                            <VTTFileTab 
                                setIsProcessing={setIsProcessing}
                                isProcessing={isProcessing}
                            />
                        </TabPane>
                    </Tabs>
                </Col>
                <Col span={24}>
                    <SpeechResults 
                        transcriptContent={transcriptContent}
                    />
                </Col>
            </Row>
        </Layout>
    );
};

export default SpeechToInsights;